<template>
  <ckeditor :editor="ClassicEditor" :value="value" @input="$emit('input', $event)" :config="editorConfig"></ckeditor>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials'
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold'
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic'
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline'
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough'
import Code from '@ckeditor/ckeditor5-basic-styles/src/code'
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript'
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Font from '@ckeditor/ckeditor5-font/src/font'
import Heading from '@ckeditor/ckeditor5-heading/src/heading'
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight'
import ListStyle from '@ckeditor/ckeditor5-list/src/liststyle'
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote'
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed'
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder'
import imageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import '@ckeditor/ckeditor5-build-classic/build/translations/ru'
import SimpleUploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter";
import axios from "axios";


export default {
  name: 'app-ckeditor',
  props:{
    value:{
      type: [String],
      default: ''
    },
    placeholder: {
      type: [Number, String],
      default: 'Заметка...'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    ClassicEditor,
    editorData: '',
    editorConfig: {
      placeholder: 'Заметка...',
      plugins: [
        MediaEmbed,
        Image, ImageToolbar, ImageCaption, ImageStyle,
        Essentials,
        LinkPlugin,
        ParagraphPlugin,
        Font,
        Heading,
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Code,
        Subscript,
        Superscript,
        Highlight,
        BlockQuote,
        CKFinder,
        ListStyle,
        imageUpload,
        SimpleUploadAdapter,

      ],
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          '|',
          'numberedList',
          'bulletedList',
          '|',
          'link',
          'blockQuote',
          'mediaEmbed',
          'imageUpload',
          '|',
          'insertImage',
          'undo',
          'redo',
        ],
        viewportTopOffset: 140,
      },
      language: 'ru',
      simpleUpload: {
        uploadUrl: axios.defaults.baseURL+'/add-image',
      }
    }
  })
}
</script>

<style lang="scss">
.ck-content{
  ol, ul{
    list-style-type: inherit;
    padding-left: 40px;
  }
  ol {
    list-style-type: decimal;
  }
  ul {
    list-style-type: inherit;
  }
  a {
    color: #2CB181;
  }
  .ck-link_selected{
    background-color: rgba(44, 177, 129, 0.1);
  }

  blockquote{
    color: #2CB181;
    padding-left: 30px;
    position: relative;
    border: none;

    &:after{
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      background: url(../assets/icons/bloquote.svg) no-repeat center;
    }
  }
}
</style>
